import React from 'react';
import dayjs from 'dayjs';
import { Drawer, List, Tag, Typography, Icon } from 'antd';
import { SyncOutlined, SettingTwoTone, ClockCircleOutline } from '@ant-design/icons';
import {
    STOCK,
    STOCK_DESCRIPTION,
    EXPIRATION,
    EXPIRATION_DESCRIPTION
} from '../../src/common/types/notificationStatusType';

export default function LayoutNotification(props) {
    return (
        <Drawer
            className="components-layout-notification"
            title="Notificaciones"
            placement="right"
            onClose={props.onClose}
            visible={props.open}
            width={400}
        >
            <List
                itemLayout="horizontal"
                size="large"
                pagination={false}
                dataSource={props.source}
                renderItem={item => (
                    <List.Item key={item.Id} style={{ background: 'white' }}>
                        <div className='inline-flex width-100'>
                            <div style={{ minWidth: '38px', height: '40px' }} className='vertical-center'>
                                {
                                    item.Status === STOCK ?
                                        <Icon style={{ fontSize: '25px', color: '#1890ff' }} type="stock" />
                                        : <Icon style={{ fontSize: '25px', color: '#1890ff' }} type="calendar" />

                                }
                            </div>
                            <div className='width-100'>
                                <Typography.Text strong className='font-size-14'>
                                    {item.CodigoReferencia}
                                </Typography.Text >
                                <br />
                                <div style={{ display: 'inline-grid', color: '#636363', marginTop: "3px" }}>
                                    <div>
                                        {item.Nombre} <br />
                                        <span>Lote: {item.Lote}</span>
                                    </div>

                                </div>
                                <div className='text-left mt-1' style={{ fontSize: '13px', color: '#6d6d6d' }}>
                                    {item.FechaVencimiento} {item.Status === STOCK ? <Tag color='purple'> Producto Baja Stock</Tag> : <Tag color='blue'>  Producto Vencido</Tag>}
                                </div>
                            </div>
                        </div>
                    </List.Item>
                )}
            />
        </Drawer>
    );
}
